import 'regenerator-runtime/runtime';
import { all } from 'redux-saga/effects';
import { watchInDashboardUebernehmenSaga } from './inDashboardUebernehmenSaga';
import { streckenTarifierungUnf } from './streckenTarifierung.saga';
import { shopTarifierungUnf } from './shopTarifierung.saga';
import { watchVorschlagdatenChanged } from './vorschlagdatenSaga';
import { watchAntragsnummerRequested } from './antragsnummerSaga';
import { watchDruckdatenChanged } from './druckdatenSaga';
import { watchStateSnapshot } from './stateSnapshotSaga';
import { watchStreckeSnapshot } from './streckeSnapshotSaga';
import { watchKusAbsprung } from './absprungToKus.saga';
import { watchVorbelegungRequested } from './vorbelegungSaga';
import { watchQuoteDB } from './quoteDbSaga';
import { watchSportDisciplineRequests } from './sportDisciplineSaga';
import { handleUnfNavigationToAngebotSaga } from './handleUnfNavigationToAngebotSaga';

export function* rootSaga() {
  yield all([
    watchInDashboardUebernehmenSaga(),
    streckenTarifierungUnf(),
    shopTarifierungUnf(),
    watchVorschlagdatenChanged(),
    watchAntragsnummerRequested(),
    watchDruckdatenChanged(),
    watchStateSnapshot(),
    watchStreckeSnapshot(),
    watchKusAbsprung(),
    watchVorbelegungRequested(),
    watchQuoteDB(),
    watchSportDisciplineRequests(),
    handleUnfNavigationToAngebotSaga(),
  ]);
}
